import api from "../../api/index";

// Get all categories
export const getAllCategories = async () => {
  const res = await api.get("/category");
  return res.data;
};

// Add a new category (requires token)
export const createCategory = async (category, token) => {
  const res = await api.post("/category", category, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

// Get a category by ID
export const getCategoryById = async (category_id) => {
  const res = await api.get(`/category/${category_id}`);
  return res.data;
};

// Update a category by ID (requires token)
export const updateCategory = async (category_id, category, token) => {
  const res = await api.put(`/category/${category_id}`, category, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

// Delete a category by ID (requires token)
export const deleteCategory = async (category_id, token) => {
  const res = await api.delete(`/category/${category_id}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};

// Create a post form template for a category (requires token)
export const createPostFormTemplate = async (
  category_id,
  formTemplate,
  token
) => {
  const res = await api.post(
    `/category/${category_id}/form_template`,
    formTemplate,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  return res.data;
};

// Get a post form template for a category
export const getPostFormTemplate = async (category_id) => {
  const res = await api.get(`/category/${category_id}/form_template`);
  return res.data;
};

// Update a post form template for a category (requires token)
export const updatePostFormTemplate = async (
  category_id,
  formTemplate,
  token
) => {
  const res = await api.put(
    `/category/${category_id}/form_template`,
    formTemplate,
    { headers: token ? { Authorization: `Bearer ${token}` } : {} }
  );
  return res.data;
};

// Delete a post form template for a category (requires token)
export const deletePostFormTemplate = async (category_id, token) => {
  const res = await api.delete(`/category/${category_id}/form_template`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return res.data;
};
